import {
    AbstractDataProviderActionParamInterface
} from "~/cabinet/vue/client/events/action/types/dataProvider/AbstractDataProviderActionParamInterface";
import {Component} from "vue";
import AbstractDataProviderActionBlockPreview
    from "~/cabinet/vue/client/events/action/types/dataProvider/AbstractDataProviderActionBlockPreview.vue";
import AbstractDataProviderActionBlockForm
    from "~/cabinet/vue/client/events/action/types/dataProvider/AbstractDataProviderActionBlockForm.vue";
import AbstractActionDescription from "~/cabinet/ts/data/events/AbstractActionDescription";
import {
    AbstractDataProviderActionDescriptionFrontendParamsInterface
} from "~/cabinet/ts/data/events/actionDescriptions/DataProvider/Interface";

export abstract class AbstractDataProviderActionDescription<Model extends AbstractDataProviderActionParamInterface, FrontendParams extends AbstractDataProviderActionDescriptionFrontendParamsInterface = AbstractDataProviderActionDescriptionFrontendParamsInterface> extends AbstractActionDescription<Model, FrontendParams> {
    get previewComponent(): Component {
        return AbstractDataProviderActionBlockPreview;
    }

    get formComponent(): Component {
        return AbstractDataProviderActionBlockForm;
    }

    get dataProviderActionFormComponent(): Component | undefined {
        return undefined;
    }

    /*
    get dataProviderActionPreviewComponent(): Component {
        return null;
    }
    */

    protected getAbstractDefaultModelValues(): AbstractDataProviderActionParamInterface {
        return {}
    }

    public abstract getDefaultModelValues(): Model;
}